@if (ready) {
  <editor
    [init]="config"
    [formControl]="controller"
    [disabled]="controller.disabled"
    [ngClass]="{'invalid': !controller.valid, 'has-focus': hasFocus, 'disabled': controller.disabled}"
    (onFocusIn)="setFocus(true)"
    (onBlur)="setFocus(false)"
  ></editor>
}
